var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterbundllogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 39,
    viewBox: "0 0 92 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.365234 37.6983V10.5469H6.06508C8.32769 10.5469 10.2804 10.6191 12.1548 12.0225C14.1058 13.4628 15.1605 15.876 15.1605 18.1448C15.1605 20.5581 14.1842 22.3949 11.9999 23.7614C14.4191 24.842 15.6287 27.7225 15.6287 30.0635C15.6287 35.4296 11.3351 37.6983 6.02676 37.6983H0.365234ZM6.18171 15.0475V21.674C8.36768 21.674 9.6556 20.306 9.6556 18.2524C9.6556 16.1988 8.406 14.9384 6.18171 15.0475ZM6.18171 25.8503V33.1962C8.52263 33.3038 9.89053 31.7205 9.89053 29.4502C9.89053 27.3259 8.48431 25.7765 6.18171 25.8488V25.8503Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8978 10.5469V28.1206C23.8978 30.1742 23.6262 33.2699 26.7869 33.2699C29.6377 33.2699 29.6377 31.2901 29.676 29.2719V10.5469H35.4924V30.3525C35.4924 33.233 35.1409 38.1318 26.7486 38.1318C21.3236 38.1318 18.083 35.7908 18.083 30.7122V10.5469H23.8978Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.447 37.6952V10.5437H57.8572C58.8719 10.5437 71.0514 9.17567 71.0514 24.3362C71.0514 32.0786 67.8107 37.6967 58.637 37.6967H53.4453L53.447 37.6952ZM65.2349 24.2993C65.2349 20.8423 64.0636 15.3671 59.2635 15.3671V32.8686C63.947 33.0854 65.2349 27.6824 65.2349 24.2977V24.2993Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7432 10.5469V32.6582H85.8313V37.6999H73.9268V10.5469H79.7432Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8623 10.6016V25.8112L41.1895 10.6016H47.8623Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1895 21.2617V37.8379L48.2122 37.6949L41.1895 21.2617Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8293 0.0742188H73.9531V5.29116H85.8293V16.2477H91.4842V5.29116V0.0742188H85.8293Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterbundllogo);
export default __webpack_public_path__ + "static/media/Footerbundllogo.e8aad6047fdfc22ceca4fdfe67a61ec6.svg";
export { ForwardRef as ReactComponent };